import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
import MasterClientContract from './../../../../masterdata/views/contracttemplate/createContractTemplate'
import CONSTANT from './../../../../shared/constants/constant';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Template1 from './../../../../shared/components/Template1'
import ClientService from '../../../services/clientmanagement.service';
import ContractTemplateView from './../../../../masterdata/views/contracttemplate/contracttemplateview';
import Multiselect from 'vue-multiselect'
export default {
  name: 'createContract',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    MasterClientContract,
    Template1,
    ContractTemplateView,
    Multiselect
  },
  props: ['CompanyShortList', 'selectedEditRowData','ContractTemplateList'],
  data: function() {
    return {
      isLoading: false,
      selectedContractTemplate: {
        value: '',
        text: ''
      },
      viewObject:{},
      contractTemplateList: [],
      contractTemplate: '',
      clientid: '',
      contractid: '',
      contracttemplateid: null,
      contractstatus: '',
      clientstatus: '',
      contractname: '',
      companyName: '',
      contracteffectivedatefrom: '',
      contracteffectivedateto: '',
      contractdescription: '',
      showTemplateFlag: false,
      showContract: false,
      checkEdit: false,
      companyNamelist: [],
      selectedcompanyName: {
        "value": '',
        "text": '',
        'CompanyName': ''
      },
      callingToContractObj: {
        id: null,
        name: CONSTANT.CLIENT_CONTRACT_TEMPLATE,
        existingContractTemplateId: null,
        newlySelectedTemplateId:null
      },
      showContractTemplate: false,
      userName: '',
      isClientServiceUpdate: false,
      clientcontractid: '',
      selectedEditRow: [],
      disabled:true,
      lock:true,
      unlock:false,
      clientbusinessaccountid:'',
      accountname:'',
      oldclientmasterid:'',
      clientbusinessdetailid:''
    }
  },
  computed: {

  },
  mounted() {
    if (this.CompanyShortList.length > 0) {
    } else {
      this.getCompanyShortName();
    }
    if (this.ContractTemplateList.length > 0) {
      this.contractTemplateList = this.ContractTemplateList;
    } else {
      this.getContractListing();
    }
    if (this.selectedEditRowData.id) {
      this.checkEdit = true;
      this.contractid = this.selectedEditRowData.id;
      this.clientid = {value:this.selectedEditRowData.clientid,
                        text : this.selectedEditRowData.clientshortname};
      this.clientshortname = this.selectedEditRowData.clientshortname;
      this.clientcompanyname = this.selectedEditRowData.clientcompanyname;
      this.clientbusinessaccountid = this.selectedEditRowData.clientbusinessaccountid;
      this.oldclientmasterid = this.selectedEditRowData.oldclientmasterid;
      this.clientbusinessdetailid = this.selectedEditRowData.clientbusinessdetailid;
      this.contracteffectivedatefrom = this.selectedEditRowData.contracteffectivedatefrom;
      this.contracteffectivedateto = this.selectedEditRowData.contracteffectivedateto;
      this.contractidtext = this.selectedEditRowData.contractidlabel;
      this.contractname = this.selectedEditRowData.contractname;
      this.contractdescription = this.selectedEditRowData.contractdescription;
      this.contracttemplateid = this.selectedEditRowData.contracttemplateid;
      this.contractstatus = CONSTANT.CONTRACT_STATUS[this.selectedEditRowData.contractstatus];

      this.selectedcompanyName = {
        "value": this.selectedEditRowData.clientid,
        "text": this.selectedEditRowData.clientshortname,
        "CompanyName": this.selectedEditRowData.companyName
      }
      this.selectedContractTemplate = {
        "value": this.selectedEditRowData.contracttemplateid,
        "text": this.getContractTemplateName(this.selectedEditRowData.contracttemplateid),
      }
      this.callingToContractObj.id = this.selectedEditRowData.id
      this.callingToContractObj.existingContractTemplateId = this.selectedEditRowData.contracttemplateid
      if (this.contractid) {
        this.getAndSetSetectedTemplateData(this.contractid, true)
      }
    }
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
  },
  methods: {
    async checkAndCopyContract(isSubmitClick, isSendForApproval){
      try {
        if(this.callingToContractObj.newlySelectedTemplateId){
          let copyRateRayload= {
          clientContractId:this.contractid,
          clientContractTemplateId:this.contracttemplateid,
          lastmodifiedby:this.userName
          }
          this.isLoading = true;
          await ClientService.copyContract(copyRateRayload);
          this.isLoading = false;
          if(isSubmitClick){
            this.$emit("goBackToParent");
            return;
          }
        } else {
          console.log("no need to copy")
        }
        if(isSendForApproval){
          this.$emit("goBackToParent");
        }
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    IsDisabled(){
      this.$confirm("Do you want to unlock the  contract for editing?","","question").then(async () => {
         this.disabled = false;
         this.lock = false;
         this.unlock = true;
         this.parentmessage = 'true'
         this.checkAndCopyContract()

      }).catch((err)=>{
        this.isLoading = false;
        console.log(err)
      });
    },
    async getCompanyShortName() {
      try {
        this.isLoading = true;
        var CompanyShortList = []
        let inputPayload = {}
        let result = await ClientService.GetCargoClientList(inputPayload)
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          if(CompanyShortList[i].ClientShortName){
            this.CompanyShortList.push({
              'value': CompanyShortList[i].ClientMasterID,
              'text': CompanyShortList[i].ClientShortName,
              'CompanyName': CompanyShortList[i].AccountName,
              'ClientBusinessAccountId' : CompanyShortList[i].ClientBusinessAccountId,
              'ClientBusinessDetailId' :  CompanyShortList[i].ClientBusinessDetailId,
              'OldClientMasterId' : CompanyShortList[i].OldClientMasterId,
            })
          }
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async getContractListing() {
      try {
        let payload = {}
        this.isLoading = true
        let result = await MasterService.getContractListingForDropDown(payload)
        this.isLoading = false;
        this.contractTemplateList = result.data.data.rows.map((el) => {
          return {
            value: el.id,
            text: el.contracttemplatename,
          }
        });
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async saveClientContract(isSendForApproval, isSubmitClick) {
      try {
        var inputPayload = {};
        this.isLoading = true;
        inputPayload.clientid = this.clientid.value,
        inputPayload.clientshortname = this.clientshortname,
        inputPayload.clientcompanyname = this.clientcompanyname,
        inputPayload.clientbusinessaccountid = this.clientbusinessaccountid,
        inputPayload.oldclientmasterid = this.oldclientmasterid,
        inputPayload.clientbusinessdetailid = this.clientbusinessdetailid,
        inputPayload.contractname = this.contractname,
        inputPayload.contractdescription = this.contractdescription,
        inputPayload.contracttemplateid = this.contracttemplateid,
        inputPayload.contracteffectivedatefrom = this.contracteffectivedatefrom,
        inputPayload.contracteffectivedateto = this.contracteffectivedateto,
        inputPayload.ftlservices = this.ftlservices,
        inputPayload.ptlservices = this.ptlservices,
        inputPayload.lastmodifiedby = this.userName;
        inputPayload.islocked = this.unlock;
        if(isSendForApproval){
          inputPayload.isapproved = "YES";
        }
        if (this.contractid) {
          inputPayload.contractid = this.contractid;
        }
        let result = await ClientService.saveClientContract(inputPayload);
        this.isLoading = false;
        //this.checkAndCopyContract();
        if (result.data.code == 200) {
          if(result.data.data){
            this.contractid = result.data.data.contractid;
            this.contractidtext = result.data.data.contractidtext;
            this.contractstatus = CONSTANT.CONTRACT_STATUS[result.data.data.contractstatus];
            this.callingToContractObj.id = result.data.data.contractid;
          }
          this.checkAndCopyContract(isSubmitClick, isSendForApproval);
          this.$alert(result.data.message, this.contractname, "success");
        } else {
          this.$alert(result.data.message, this.contractname, "error");
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    getContractTemplateName(templateid){
      for (var i = 0; i < this.contractTemplateList.length; i++) {
        if (this.contractTemplateList[i].value == templateid) {
          return this.contractTemplateList[i].text;
        }
      }
    },
    async saveContractService(payload, buttonclick) {
      try {
        payload.contractid = this.contractid;
        payload.contracttemplateid = this.contracttemplateid;
        this.isClientServiceUpdate = true;
        let result = await ClientService.saveClientContractServices(payload);
        // let copyRateRayload= {
        //   clientContractId:this.contractid,
        //   clientContractTemplateId:this.contracttemplateid,
        //   lastmodifiedby:this.userName
        //   }
        // if(!this.callingToContractObj.existingContractTemplateId){
        //   let copyResult = await ClientService.copyContractRate(copyRateRayload);
        //   console.log("rate Response",copyResult);
        // }
        this.isClientServiceUpdate = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.companyShortName, "success");
          this.showContractTemplate = false;
          this.$nextTick(async () => {
            this.callingToContractObj.id=this.contractid
            this.callingToContractObj.existingContractTemplateId = this.contracttemplateid;
            this.callingToContractObj.newlySelectedTemplateId = null;
            this.showContractTemplate = true;
            this.$nextTick(()=>{
              this.$refs.ContractChilds.getContractID(this.contractid, buttonclick);
            })
          })
        } else {
          this.$alert(result.data.message, this.companyShortName, "error");
        }
      } catch (err) {
        this.isClientServiceUpdate = false;
        this.$alert(err, "Contract", "error");
        console.log(err);
      }
    },
    async getAndSetSetectedTemplateData(id, isFromClient, isMasterView) {
      try {
        this.isLoading = true
        this.showContractTemplate = false;
        let payload = {
          offset: 0,
          limit: 1,
          // contractTemplateId: id
        }
        this.$nextTick(async () => {
          if (isFromClient) {
            payload.clientContractTemplateId = id
            var result = await ClientService.getClentContractDetial(payload)
          } else {
            payload.contractTemplateId = id
            var result = await MasterService.getContractDetial(payload)
          }
          this.isLoading = false;
          this.selectedEditRow = result.data.data.rows[0]
          this.showContractTemplate = true;
          // result.data.data.rows[0].parentComponent = 'ClentContract'
          if(isMasterView){
              this.viewObject = {
                id: id,
                view:true,
                ComponentName: CONSTANT.CONTRACT_TEMPLATE,
            }} else {
            this.viewObject = {
              id: this.selectedEditRow.id,
              clientID: this.selectedEditRow.clientid,
              contractID: this.selectedEditRow.contractidlabel,
              ComponentName: CONSTANT.CLIENT_CONTRACT_TEMPLATE,
              uom: this.selectedEditRow.uom,
              view: true
            }
          }

        })
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    selectContractTemplate(data) {
      this.selectedContractTemplate = data;
      this.contracttemplateid = data.value;
      this.callingToContractObj.newlySelectedTemplateId = data.value;
      this.callingToContractObj.existingContractTemplateId = null;
      this.lock = true;
      this.unlock = false;
      this.disabled = true;
      // this.viewObject = {
      //   id: data.value,
      //   // clientID: this.clientid,
      //   // contractID: this.contractidtext,
      //   view:true,
      //   ComponentName: CONSTANT.CONTRACT_TEMPLATE,
      // }
      this.getAndSetSetectedTemplateData(data.value, null, true);
    },
    showCreateContract() {
      this.$emit("goBackToParent")
    },
    selectCompanyName(data) {
      this.selectedcompanyName = data;
      this.clientid = data.value
      this.clientcompanyname = data.CompanyName;
      this.clientshortname = data.text;
      this.clientbusinessaccountid = data.ClientBusinessAccountId;
      this.oldclientmasterid = data.OldClientMasterId;
      this.clientbusinessdetailid = data.ClientBusinessDetailId;
    },
    eventFromChild() {
      console.log("event from child")
    },
    onSubmit(isSendForApproval, isSubmitClick) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveClientContract(isSendForApproval, isSubmitClick);
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
  },
}

Validator.extend('verify_todate', {
  getMessage: field => "Contract Effective To Date should be greater than Contract Effective From Date.",
  validate: value => {
    var todate = new Date($("#effectiveTodate").val());
    var fromdate = new Date($("#effectiveFromdate").val());
     if (fromdate >= todate) {
      return false;
    }else{
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientContract/CreateClientContract/CreateClientContract.component.js